import Aria from "../../util/Aria";
import { Timeout, dateFormatter, setStylesOnElement } from "../../util/Misc";
import BubbleType from "../../model/BubbleType";
import {
    handleRichMediaAction,
    logSelectedLink,
    renderRichMediaWidget,
    setAgentSpeechAvatar
} from "./controller/BubbleController";
import { Constants, FOCUS_ON_OPEN } from "../../model/Constants";
import pubSubInstance from "../../util/pubSubGlobal";
import {richviewsRender} from "../templates/renders/richviews";

/* eslint-disable no-param-reassign */

const RichView: any = {
    tagName: "rich-view",
    renderer: richviewsRender,
    created() {
        this.ariaUtil = new Aria(this.$app);
        this.msgInfo = this.el.querySelector(".msg-info");
    },

    /**
     * Renders the rich message text and widget
     * @param {Message} message
     */
    render(message) {
        const rData = message.getRichData();
        const cont = this.getContainer();
        this.setSpeechImage(message, rData);

        if (message.getMessageText() && rData.showMessageText && !message.isEmptyResponse()) {
            const view: any = document.createElement("agent-simple-view");
            cont.appendChild(view);
            view.render(message);
        } else if (this.msgInfo && !rData.customerAction) {
            this.msgInfo.classList.remove("hide");
            this.agentAliasEl = this.msgInfo.querySelector(".msg-info-name span");
            this.timeEl = this.msgInfo.querySelector(".msg-info-time span");

            if (this.agentAliasEl) {
                this.agentAliasEl.innerText = message.getName();
            }

            // set time value  in info element
            if (this.timeEl) {
                this.timeEl.innerText = dateFormatter(parseInt(message.getTimeStamp(), 10), this.format);
            }
        }

        if(rData.hideAfterMessage !== undefined && rData.hideAfterMessage === true){
            this.el.setAttribute('hideAfterMessage',rData.hideAfterMessage);
        }

        this.richContainer = document.createElement("div");
        this.updateStyleProps(this.richContainer, message);
        cont.appendChild(this.richContainer);
        this.richContainer.classList.add("rich-container");
        this.renderRichView(rData, message);
        message.setRichInstance(this.richInstance);
        pubSubInstance.publish(Constants.AGENT_OR_RICH_MEDIA_MESSAGE_RENDERED, this.richContainer);
    },
    reload(message) {
        if (this.richInstance) {
            this.richInstance.clearAll();
        }

        this.richContainer.classList.remove("enter");
        const rData = message.getRichData();
        this.renderRichView(rData, message);
        message.setRichInstance(this.richInstance);
    },

    /**
     * creates and return the RichEngine instance
     * @param {Object} richData - rich widget json
     * @param {Message} message - Rich Widget message object
     * @return {RichMain}
     */
    renderRichView(richData, message) {
        if (window.RichMain) {
            this.richInstance = window.RichMain.instance;
            let shouldLock = false;
            let shouldReport = this.richmediaReporting;

            if (message.getIsRestore() && !message.isLast()) {
                shouldLock = typeof richData.lockView === "undefined" ? true : richData.lockView;
                shouldReport = false;
            } else if (this.speechCon) {
                this.speechCon.classList.remove("enter");
            }

            renderRichMediaWidget(this.richInstance, this.$app,
                richData.customerAction ? richData.receipt : richData,
                this.richContainer,
                richData.customerAction || shouldLock,
                shouldReport,
                outputText => {
                    this.setAccessibilityFocus(outputText, richData, message);
                });

            handleRichMediaAction(this.$app, this.richInstance, this.logLinks);

            if (message.getIsRestore()) {
                this.richContainer.classList.add("enter");
            } else {
                if (Timeout.exists("richTimer") && !Timeout.executed("richTimer")) {
                    Timeout.clear("richTimer")();
                }

                Timeout.set("richTimer", () => {
                    if (this.speechCon) {
                        this.speechCon.classList.add("enter");
                    }

                    this.richContainer.classList.add("enter");

                    if (richData.customerAction) {
                        delete richData.customerAction;
                        this.sendData(message, richData);
                    }
                }, richData.customerAction ? this.richWidgetReceiptTimer : 25);
            }

            if (!richData.customerAction) {
                this.richContainer.addEventListener("click", event => {
                    if (event.target.tagName.toLowerCase() === "a") {
                        // top window navigation
                        if (this.logLinks) {
                            logSelectedLink(this.$app, this.logLinks, event.target.href);
                        }

                        this.$app.bridge.pushToFrameSet(event.target.href, event.target.target);
                        event.preventDefault();
                    }
                });
            }
        }
    },
    updateStyleProps(cont, message) {
        let props = this.richStyleProps.other;
        let styles = this.otherstyle;

        switch (message.getMessageBubble()) {
            case BubbleType.RICH_MESSAGE_CARD:
                props = this.richStyleProps.card;
                styles = this.cstyle;
                break;

            case BubbleType.RICH_MESSAGE_QR:
                props = this.richStyleProps.qr;
                styles = this.qrstyle;
                break;

            case BubbleType.RICH_MESSAGE_FORM:
                props = this.richStyleProps.form;
                styles = this.formstyle;
                break;

            case BubbleType.RICH_MESSAGE_RECEIPT:
                props = this.richStyleProps.receipt;
                styles = this.receiptstyle;
                break;

            // no default
        }

        setStylesOnElement(props, cont);
        setStylesOnElement(styles, cont);
    },
    sendData(message, rData) {
        Timeout.set("richRTimer", () => {
            this.$app.getSDKInstance().sendRichContentMessage(
                message.getMessageText(),
                rData,
                this.$app.onEngageResponse.bind(this.$app)
            );
        }, this.richWidgetReceiptTimer);
    },
 
    /**
     * Set speech image and position if speech view is enabled
     * @param {Message} message
     * @param {Object} richData
     */
    setSpeechImage(message, richData) {
        // if message text is rendering then agent awatar is rendered from agent bubble view
        if (this.showAvatar && !richData.showMessageText) {
            setAgentSpeechAvatar.bind(this)(message);
        }
    },
    getContainer() {
        return this.el.querySelector(".richBubbleContainer");
    },

    /**
     * execute focus setting only if rich media rendered while not restoring,
     * and not for widget that is rendered as a result of customer action
     * @param ariaOutputs
     * @param richData
     * @param {Message} message - Rich Widget message object
     */
    setAccessibilityFocus(ariaOutputs, richData, message) {
        let announce = false;

        if (!message.getIsRestore()) {
            if (richData.showMessageText) {
                announce = true;
                const msgTextBubble = this.el.querySelector(".agent-bubble");
                this.$app.focusMgr.handleFocusSetting(
                    msgTextBubble,
                    richData.focusSettingMode || this.focusSettingMode
                );
                this.ariaUtil.announceBubbleText(message.getMessageText(), message.getName());
            } else if (!richData.customerAction) {
                announce = this.$app.focusMgr.handleFocusSetting(
                    this.el.querySelector(".nuan-widget-container"),
                    richData.focusSettingMode
                );
            }
        }

        const isLast = message.isLast();

        if (announce || isLast) {
            this.ariaUtil.announceRichDataMessage(ariaOutputs);
        }

        if (isLast) {
            this.$app.focusMgr.setFocusIfFocusNotInTranscript();
        }
    },
};

export default appInstance => {
    RichView.$app = appInstance;

    const constObj: any = {};
    const styleConfig: any = {};
    let richStyleProps;
    const config = appInstance.getUIConfig();

    if (config.transcriptConfig) {
        const tConfig = config.transcriptConfig;

        constObj.cstyle = tConfig.richCardViewStyles;
        constObj.qrstyle = tConfig.richQRViewStyles;
        constObj.formstyle = tConfig.richFormViewStyles;
        constObj.receiptstyle = tConfig.richReceiptViewStyles;
        constObj.otherstyle = tConfig.richOtherViewStyles;
        constObj.agentSpeechConfig = tConfig.agentSpeechAvatarConfig;
        constObj.vaSpeechConfig = tConfig.vaSpeechAvatarConfig;
        constObj.openerSpeechConfig = tConfig.openerSpeechAvatarConfig;
        constObj.nameStyle = tConfig.agentAliasStyles;
        constObj.timeStyle = tConfig.dateTimeStyles;
        constObj.avatarStyle = tConfig.speechAvatarStyles;
        constObj.focusSettingMode = appInstance.focusOnAgentMessage;
        richStyleProps = config.transcriptConfig.richStyleProperties || {};
    } else {
        richStyleProps = {};
    }

    const appConfig = config.appConfigProps;

    if (appConfig) {
        constObj.richWidgetReceiptTimer = appConfig.richWidgetReceiptTimer || 50;
        constObj.showName = appConfig.displayAgentAliasInRichWidget;
        constObj.showTime = appConfig.displayDateAndTimeInRichWidget;
        constObj.showRichInfo = constObj.showName || constObj.showTime;
        constObj.format = appConfig.timeStampFormat || "HH:mm";
        constObj.showAvatar = appConfig.setAgentSpeechView && appConfig.showRichAvatar;
        constObj.speechPos = appConfig.speechImgPosition;
        constObj.richmediaReporting = appConfig.enableRichMediaReporting;
        constObj.logLinks = appConfig.logSelectedLinks;
    }

    styleConfig.card = {};
    styleConfig.card.marginLeft = `${richStyleProps.cardViewLeftMargin || 0}px`;
    styleConfig.card.marginBottom = `${richStyleProps.cardViewBottomMargin || 15}px`;
    styleConfig.card.marginRight = `${richStyleProps.cardViewRightMargin || 0}px`;
    styleConfig.card.marginTop = `${richStyleProps.cardViewTopMargin || -10}px`;

    styleConfig.form = {};
    styleConfig.form.marginLeft = `${richStyleProps.formViewLeftMargin || 0}px`;
    styleConfig.form.marginBottom = `${richStyleProps.formViewBottomMargin || 15}px`;
    styleConfig.form.marginRight = `${richStyleProps.formViewRightMargin || 0}px`;
    styleConfig.form.marginTop = `${richStyleProps.formViewTopMargin || -10}px`;

    styleConfig.qr = {};
    styleConfig.qr.marginLeft = `${richStyleProps.qrViewLeftMargin || 0}px`;
    styleConfig.qr.marginBottom = `${richStyleProps.qrViewBottomMargin || 15}px`;
    styleConfig.qr.marginRight = `${richStyleProps.qrViewRightMargin || 0}px`;
    styleConfig.qr.marginTop = `${richStyleProps.qrViewTopMargin || -10}px`;

    styleConfig.receipt = {};
    styleConfig.receipt.marginLeft = `${richStyleProps.receiptViewLeftMargin || 0}px`;
    styleConfig.receipt.marginBottom = `${richStyleProps.receiptViewBottomMargin || 15}px`;
    styleConfig.receipt.marginRight = `${richStyleProps.receiptViewRightMargin || 0}px`;
    styleConfig.receipt.marginTop = `${richStyleProps.receiptViewTopMargin || -10}px`;

    styleConfig.other = {};
    styleConfig.other.marginLeft = `${richStyleProps.otherViewLeftMargin || 0}px`;
    styleConfig.other.marginBottom = `${richStyleProps.otherViewBottomMargin || 15}px`;
    styleConfig.other.marginRight = `${richStyleProps.otherViewRightMargin || 0}px`;
    styleConfig.other.marginTop = `${richStyleProps.otherViewTopMargin || -10}px`;

    constObj.richStyleProps = styleConfig;
    RichView.constants = constObj;

    return RichView;
};
